var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereumLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 76,
    viewBox: "0 0 46 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0187 53.1412V0.838562L0.886719 39.1061L23.0187 53.1412Z",
    fill: "#7E7E7E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0186 0.838562L45.1505 39.1061L23.0186 53.1412V0.838562Z",
    fill: "#2E2E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.886719 43.6383L23.0554 57.7099V75.8386",
    fill: "#7E7E7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1505 43.6383L23.0186 57.7099V75.8386",
    fill: "#2E2E2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.0183 26.5695L0.849609 39.1061L23.0183 53.1412V26.5695Z",
    fill: "#323232"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M23.0186 26.5695L45.1505 39.1061L23.0186 53.1412V26.5695Z",
    fill: "#121212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0187 53.1412V0.838562L0.886719 39.1061L23.0187 53.1412Z",
    fill: "#ECEEF3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0186 0.838562L45.1505 39.1061L23.0186 53.1412V0.838562Z",
    fill: "#ECEEF3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M23.0186 0.838562L45.1505 39.1061L23.0186 53.1412V0.838562Z",
    fill: "#313131"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.886719 43.6383L23.0554 57.7099V75.8386",
    fill: "#ECEEF3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1505 43.6383L23.0186 57.7099V75.8386",
    fill: "#ECEEF3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M45.1505 43.6383L23.0186 57.7099V75.8386",
    fill: "#313131"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M23.0183 26.5695L0.849609 39.1061L23.0183 53.1412V26.5695Z",
    fill: "#313131"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M23.0186 26.5695L45.1505 39.1061L23.0186 53.1412V26.5695Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumLight);
export default __webpack_public_path__ + "static/media/ethereum_light.d3fea638.svg";
export { ForwardRef as ReactComponent };